var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFdicLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_00000142147117521187182350000013571147420057927575_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 37.4 15.7",
    style: {
      enableBackground: "new 0 0 37.4 15.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "polygon3",
    className: "st0",
    points: "4,15.7 0,15.7 0,0.1 8.2,0.1 8.2,4.2 4,4.2 4,6.7 8,6.7 8,10.8 4,10.8  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5",
    className: "st0",
    d: "M21.3,7.9c0-7.2-6-7.8-8.5-7.8h-4v15.6h4v-4.1V4.1c2.5,0,4.6,1,4.6,3.8s-2.1,3.8-4.6,3.8v4.1 C15.9,15.7,21.3,15.1,21.3,7.9L21.3,7.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect7",
    x: 22,
    y: 0,
    className: "st0",
    width: 4,
    height: 15.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9",
    className: "st0",
    d: "M34.1,11.6c-1.9,0-3.5-1.7-3.5-3.7s1.6-3.7,3.5-3.7c1.8,0,2.7,1,3.3,2.3V0.8c0,0-1.8-0.8-3.4-0.8 c-3.6,0-7.6,3.6-7.6,7.9c0,5.2,3.8,7.9,7.6,7.9c1.6,0,3.4-0.8,3.4-0.8V9.3C36.6,10.6,35.8,11.6,34.1,11.6L34.1,11.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFdicLogoWhite);
export default __webpack_public_path__ + "static/media/FdicLogoWhite.a6265af5936c7040acd69638ec3eef02.svg";
export { ForwardRef as ReactComponent };